import type { AxiosInstance } from 'axios';
import type {
  Inspection,
  InspectionListQueryParams,
  InspectionCreateRequest,
  InspectionUpdateRequest,
  EntityId,
} from '@/types';

export const getInspections = async (
  api: AxiosInstance,
  type: string,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<Inspection[]> => {
  const resp = await api.get<Inspection[]>('/inspection', {
    params: { type, limit, start_key, name } as InspectionListQueryParams,
  });
  return resp.data;
};

export const getInspection = async (
  api: AxiosInstance,
  inspection_id: EntityId,
): Promise<Inspection> => {
  const resp = await api.get<Inspection>(`/inspection/${inspection_id}`);
  return resp.data;
};

export const createInspection = async (
  api: AxiosInstance,
  values: InspectionCreateRequest,
): Promise<Inspection> => {
  const resp = await api.post<Inspection>(`/inspection/`, values);
  return resp.data;
};

export const updateInspection = async (
  api: AxiosInstance,
  inspection_id: EntityId,
  values: InspectionUpdateRequest,
): Promise<Inspection> => {
  const resp = await api.put<Inspection>(
    `/inspection/${inspection_id}`,
    values,
  );
  return resp.data;
};

export const deleteInspection = async (
  api: AxiosInstance,
  inspection_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(`/inspection/${inspection_id}`);
  return resp.data;
};

export const runInspection = async (
  api: AxiosInstance,
  inspection_id: EntityId,
): Promise<unknown> => {
  const resp = await api.post(`/inspection/${inspection_id}/run`);
  return resp.data;
};

export const finalizeInspection = async (
  api: AxiosInstance,
  inspection_id: EntityId,
): Promise<unknown> => {
  const resp = await api.post(`/inspection/${inspection_id}/finalize`);
  return resp.data;
};
